import {XHTTP} from '@/shared/xhttp';
import {ApprovisionnementService} from "@/xhttp";
import {Pile, Transporteur} from "@/models";
import {DateHelper} from "@/shared/utils";
import {BoisType} from "@/models/BoisType";
import {LongueursVente} from "@/models/LongueursVente";
import {Fournisseur} from "@/models/Fournisseur";

@XHTTP(ApprovisionnementService, '/approvisionnements')
export class Approvisionnement {

	private _id: number;
	private _date: Date = new Date();
	private _numberCoupe: string;
	private _location: string;
	private _fournisseur: Fournisseur;
	private _nameDivers: string;
	private _transporteur: Transporteur;
	private _chauffeur: string;
	private _boisType: BoisType;
	private _longueursVente: LongueursVente;
	private _volume: number;
	private _pile: Pile;
	private _createdAt: Date;
	private _numFacture: string;
	private _facturer: boolean;

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}

	public get date(): Date {
		return this._date;
	}

	public get facturer(): boolean {
		return this._facturer;
	}

	public get numFacture(): string {
		return this._numFacture;
	}

	public get numberCoupe(): string {
		return this._numberCoupe;
	}

	public get location(): string {
		return this._location;
	}

	public get fournisseur(): Fournisseur {
		return this._fournisseur;
	}

	public get nameDivers(): string {
		return this._nameDivers;
	}

	public get transporteur(): Transporteur {
		return this._transporteur;
	}

	public get chauffeur(): string {
		return this._chauffeur;
	}

	public get boisType(): BoisType {
		return this._boisType;
	}

	public get longueursVente(): LongueursVente {
		return this._longueursVente;
	}

	public get volume(): number {
		return this._volume;
	}

	public get pile(): Pile {
		return this._pile;
	}

	public get createdAt(): Date {
		return this._createdAt;
	}

	/////////////
	// Setters //
	/////////////

	public set date(value: Date) {
		this._date = value;
	}

	public set numberCoupe(value: string) {
		this._numberCoupe = value;
	}

	public set facturer(value: boolean) {
		this._facturer = value;
	}

	public set numFacture(value: string) {
		this._numFacture = value;
	}

	public set location(value: string) {
		this._location = value;
	}

	public set fournisseur(value: Fournisseur) {
		this._fournisseur = value;
	}

	public set nameDivers(value: string) {
		this._nameDivers = value;
	}

	public set transporteur(value: Transporteur) {
		this._transporteur = value;
	}

	public set chauffeur(value: string) {
		this._chauffeur = value;
	}

	public set boisType(value: BoisType) {
		this._boisType = value;
	}

	public set longueursVente(value: LongueursVente) {
		this._longueursVente = value;
	}

	public set volume(value: number) {
		this._volume = value;
	}

	public set pile(value: Pile) {
		this._pile = value;
	}

	///////////////
	// Serialize //
	///////////////+

	public toJSON(): any {
		return {
			id       : this._id,
			date    : this._date ? DateHelper.toLocalizedStringWithTimeZero(this._date) : null,
			numberCoupe : this._numberCoupe,
			numFacture : this._numFacture,
			facturer : this._facturer,
			location : this._location,
			fournisseur  : this._fournisseur ? this._fournisseur.id : null,
			nameDivers : this._nameDivers,
			transporteur  : this._transporteur ? this._transporteur.id : null,
			chauffeur: this._chauffeur,
			boisType : this._boisType,
			longueursVente : this._longueursVente,
			volume : this._volume,
			pile  : this._pile ? this._pile.id : null,
		};
	}

	public fromJSON(data: any): this {
		this._id        = data.id;
		this._date         = data.date ? DateHelper.fromLocalizedString(data.date) : null;
		this._numberCoupe  = data.numberCoupe;
		this._numFacture  = data.numFacture;
		this._facturer  = data.facturer;
		this._location  = data.location;
		this._fournisseur   = data.fournisseur ? (new Fournisseur()).fromJSON(data.fournisseur) : null;
		this._nameDivers  = data.nameDivers;
		this._transporteur   = data.transporteur ? (new Transporteur()).fromJSON(data.transporteur) : null;
		this._chauffeur = data.chauffeur;
		this._boisType   = data.boisType ? (new BoisType()).fromJSON(data.boisType) : null;
		this._longueursVente   = data.longueursVente ? (new LongueursVente()).fromJSON(data.longueursVente) : null;
		this._volume  = data.volume;
		this._pile   = data.pile ? (new Pile()).fromJSON(data.pile) : null;
		this._createdAt                  = data.createdAt ? new Date(data.createdAt) : null;
		return this;
	}
}